export default __webpack_public_path__ + "static/media/logo-vw.36d3d19b.svg";